<template>
  <div class="modal-content">
    <input id="searchStation" class="input-station" :placeholder="$t('require_station')" v-model="name" />
    <div
      v-for="(station, index) in stations"
      v-bind:key="index"
      v-on:click="callback(station)"
      class="station-name">
      {{ station }}
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  props: {
    callback: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      name: undefined
    }
  },
  created: function () {
    this.debouncedSearchStation = _.debounce(this.search, 500)
  },
  methods: {
    search: function (name) {
      this.$store.dispatch('stations/search', name)
    }
  },
  computed: {
    ...mapGetters({
      stations: 'stations/getStations'
    })
  },
  watch: {
    name: function (val) {
      if (val.length > 0) {
        this.debouncedSearchStation(val)
      }
    }
  }
}
</script>
